import React from 'react';

const InteractionHints: React.FC = () => {
    return (
        <div className="interaction-hints-container">
            <div className="interaction-hint-text">
                <span className="interaction-hint-bold">Planètes</span> • Découvrir les projets
            </div>
            <div className="interaction-hint-text">
                <span className="interaction-hint-bold">Soleil</span> • En savoir plus sur moi
            </div>
        </div>
    );
};

export default InteractionHints;
